import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {LinkItem} from '@catui/types';
import {EntityForm} from '@catuimodels/shared/entity-form';
import {Subscription} from "rxjs";
import {isNullOrUndefined} from "util";
import {Router} from "@angular/router";

const componentBaseName = 'feature-option-token-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-option-token-form',
  templateUrl: './feature-option-token-form.component.html',
  styleUrls: ['./feature-option-token-form.component.scss'],
})
export class FeatureOptionTokenFormComponent extends EntityForm implements OnInit, OnDestroy {

  labels = {
    value: 'Value',
    description: 'Description',
    feature: 'Feature',
    label: 'Label',
  };
  @HostBinding('class') classNames = defaultClassNames;

  linkedParameterItems: LinkItem[] = [];

  feature: Feature;
  private featureSubscription: Subscription;

  constructor(formBuilder: FormBuilder,
              private router: Router,
              private featureService: FeatureTypeService) {
    super(formBuilder);
  }

  ngOnInit() {
    this.featureSubscription = this.featureService
      .getCurrent()
      .subscribe((feature: Feature) => this.feature = feature);
  }

  ngOnDestroy() {
    if (!isNullOrUndefined(this.featureSubscription)) {
      this.featureSubscription.unsubscribe();
    }
  }

  afterDelete() {
    this.featureService.refreshCurrent();
    this.router.navigate(['features', this.feature.id, 'option-tokens']);
  }

  protected afterFormSubmit(result: any) {
    this.featureService.refreshCurrent();
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/feature-option-tokens/components/feature-option-token-form/feature-option-token-form.component.ts